<template>
  <BFormGroup
    class="d-inline-block w-100"
    :label="inputLabel"
    :label-for="inputId"
  >
    <BInputGroup class="input-group-merge w-100">
      <BFormInput
        :disabled="readonly"
        :readonly="readonly"
        :value="createJalaliDate(value)"
        :id="inputId"
        :class="inputId"
        :placeholder="inputPlaceholder"
      ></BFormInput>
      <BInputGroupAppend is-text>
        <template v-if="value && !readonly">
          <FeatherIcon
            @click="clearDateFilter"
            class="cursor-pointer text-danger"
            icon="XIcon"
            size="18"
          />
        </template>
        <template v-else>
          <FeatherIcon class="cursor-pointer" icon="ClockIcon" size="18" />
        </template>
        <date-picker
          simple
          :disabled="readonly"
          :value="value"
          @input="emitEvent"
          :min="min"
          :max="max"
          :locale="locale"
          :customInput="`.${inputId}`"
          :jumpMinute="jumpMinute"
          :roundMinute="roundMinute"
          :format="format ? format : properFormat"
          :input-format="inputFormat ? inputFormat : properInputFormat"
          :display-format="displayFormat ? displayFormat : properDisplayFormat"
          :type="type"
        ></date-picker>
      </BInputGroupAppend>
    </BInputGroup>
  </BFormGroup>
</template>
<script>
export default {
  emits: ["getSelectedDate", "input"],
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, Number, null],
      default: null,
    },
    defaultSelectedDate: {
      type: [String],
      default: null,
    },
    min: {
      default: null,
    },
    max: {
      default: null,
    },
    roundMinute: {
      type: Boolean,
      default: true,
    },
    jumpMinute: {
      type: [Number, String],
      default: 10,
    },
    type: {
      type: String,
      default: "date",
    },
    format: {
      type: String,
      required: false,
    },
    inputFormat: {
      type: String,
      required: false,
    },
    displayFormat: {
      type: String,
      required: false,
    },
    locale:{
      type: String
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    inputLabel: {
      type: [String, null],
      default: "",
    },
    inputPlaceholder: {
      type: [String, null],
      default: "تاریخ",
    },
    inputId: {
      type: String,
      required: false,
      default: "dateFilter",
    },
  },
  data() {
    return {
      selectedDate: null,
    };
  },
  methods: {
    emitEvent(event) {
      this.$emit("input", event);
      this.$emit("getSelectedDate", event);
    },
    createJalaliDate(date) {
      if (date) {
        if (this.type == "time") {
          return new Date(date).toLocaleTimeString("fa-IR", {
            hour: "2-digit",
            minute: "2-digit",
          });
        }
        if(this.type ==='year-month'){
        return new Date(date).toLocaleDateString("fa-IR",{
          year:'numeric',
          month:'numeric'
        });
        }else{
          return new Date(date).toLocaleDateString("fa-IR");

        }
      } else {
        return null;
      }
    },
    clearDateFilter() {
      this.selectedDate = null;
      this.$emit("input", null);
      this.$emit("getSelectedDate", null);
    },
  },
  computed: {
    properFormat() {
      if (this.type == "date") {
        return "YYYY-MM-DD";
      } else if (this.type == "datetime") {
        return "YYYY-MM-DD HH:mm";
      } else {
        return "YYYY-MM-DD HH:mm";
      }
    },
    properInputFormat() {
      if (this.type == "date") {
        return "YYYY/MM/DD";
      } else if (this.type == "datetime") {
        return "YYYY/MM/DD HH:mm";
      } else {
        return "YYYY/MM/DD HH:mm";
      }
    },
    properDisplayFormat() {
      if (this.type == "date") {
        return "jYYYY/jMM/jDD";
      } else if (this.type == "datetime") {
        return "jYYYY/jMM/jDD - HH:mm";
      } else {
        return "HH:mm";
      }
    },
  },
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
  },
};
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
</script>
<style>
.vpd-next {
  margin-left: 50px !important;
}
.vpd-content,
.vpd-time {
  border-radius: 0.75rem;
}

.vpd-column-header {
  margin-bottom: 0.5rem;
}

.vpd-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vpd-column-header,
.vpd-simple-content {
  border-bottom: 1px solid #bebebe;
}
</style>
